import { ref } from 'vue';
import { message, vueCreateAppInit } from '@/utils/js/initVariable';
import { getMapBoxPlacesGeometry } from '@/api/MapManage';
import CustomLocaleControl from '../index.vue';

/**
 * OSM 地理信息请求/初始化/图层管理
 * @param {Object} props - 组件 props
 * @param {Object} osmLayerGroup - OSM 图层组 
 * @param {Function} osmLayerGroupClear - 清除图层组函数
 * @param {String} loadProp - loading 属性名
 */
export function useOsmData(props, osmLayerGroup, osmLayerGroupClear, loadProp) {
  const layerCustomLocaleControlInit = (layer, target, group) => {
    const bounds = layer.getBounds();
    const layerClick = (event) => {
      const icon = controlMarker && controlMarker._icon;
      if (!icon) return;
      const display = icon.style.display;
      if (display === 'none') {
        icon.style.display = 'unset';
      } else {
        icon.style.display = 'none';
      }
    }
    const app = vueCreateAppInit(CustomLocaleControl, {
      target,
      layer,
      onLayerDelete: () => {
        group.removeLayer(layer);
        controlMarker && group.removeLayer(controlMarker);
      },
      layerGroup: group,
      layerClick,
    });
    const div = document.createElement('div');
    app.mount(div);

    const controlMarker = L.marker(bounds.getNorthEast(), {
      icon: L.divIcon({
        iconAnchor: [-5, 0],
        html: div,
      }),
    }).on({
      remove: event => {
        app.unmount();
      },
    }).addTo(group);
  }

  const osmDataInit = (data) => {
    JSON.parse(data).forEach(item => {
      let bindText = '';
      const properties = item['geojson']['properties'];
      if (properties['name']) {
        bindText += `<p>${properties['name']}</p>`
      }
      let layer;
      const geojson = L.geoJSON(item['geojson'], {
        onEachFeature: (feature, l) => {
          l.setStyle({
            color: 'rgb(242, 186, 44)',
          })
          layer = l;
        },
      })

      if (!(layer instanceof L.Polygon)) return;
      layer.addTo(osmLayerGroup);
      layer.once({
        click: event => {
          layerCustomLocaleControlInit(layer, {}, osmLayerGroup);
        }
      })
      if (bindText !== '') {
        layer.bindTooltip(bindText, {
          sticky: true,
          className: "leaflet-tooltip-message",
          direction: 'top',
        })
      }
    })
  }

  // 地理信息请求
  const osmRequest = (btn) => {
    btn[loadProp.value] = true;
    const layer = props.layer;
    const flag = layer instanceof L.Polygon;
    if (!flag) return;
    osmLayerGroupClear();

    getMapBoxPlacesGeometry({
      minLat: layer.getBounds().getSouthEast().lat,
      minLon: layer.getBounds().getNorthWest().lng,
      maxLat: layer.getBounds().getNorthWest().lat,
      maxLon: layer.getBounds().getSouthEast().lng,
    }).then(res => {
      if (res.data.code === 1004) {
        osmDataInit(res.data.data);
      }
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      btn[loadProp.value] = false;
    });
  }

  return { osmRequest, layerCustomLocaleControlInit };
}
